import React, {useState} from "react";
import {useQuery} from "react-query";
import {deleteEnrollments, getEnrollments} from "../../Api/Query/Enrollments";
import {RequireAuth} from "../../Components/Security/RequireAuth";
import {Button, Col, Form} from "react-bootstrap";
import {Notificator} from "../../Services/Notificator/Notificator";
import {forceDownloadFromUrl} from "../../Services/File/FileDownloader";
import {Link} from "react-router-dom";
import {ROUTE_PATHS} from "../../Config/Router/Routes";
import {AdminCrudList} from "../Shared/Crud/AdminCrudList";
import {Enabled} from "../../Components/Enabled/Enabled";
import {CenterSelect} from "../../Components/Center/CenterSelect";
import {SelectOptionType} from "../../Model/Select/SelectOption";

export const ListEnrollments: React.FC = () => {

    const [searchFilterValue, setSearchFilterValue] = useState<string>('')
    const [selectedCenter, setSelectedCenter] = useState<SelectOptionType | null>(null)
    const [customFiltersData, setCustomFiltersData] = useState<{ [key: string]: any }>({})
    const [isExporting, setIsExporting] = useState<boolean>(false)

    const exportQuery = useQuery({
        enabled: false,
        queryKey: ['exportEnrollments'],
        queryFn: () => getEnrollments({...customFiltersData, export: 1}),
        onSuccess: (response: any) => {
            forceDownloadFromUrl(response.data._result.url)
            setIsExporting(false)
        },
        onError: () => {
            Notificator.error('Se ha producido un error al exportar.')
            setIsExporting(false)
        }
    })

    const headers: string[] = [
        'Nombre',
        'Precio',
        'Habilitado',
        'Fecha actualización',
    ]

    const onEnterPressed = (event: React.KeyboardEvent): void => {
        if (event.key !== 'Enter') return
        applyFilters(searchFilterValue, selectedCenter)
    }

    const applyFilters = (search: string, center: SelectOptionType | null) => {
        const filters: { [key: string]: any } = {}
        if (search) filters['q'] = `*${search}*`
        if (center?.value) filters['centerId'] = center.value
        setCustomFiltersData(filters)
    }

    return (
        <RequireAuth>
            <AdminCrudList
                title={"Listado de matrículas"}
                headers={headers}
                queryMethod={getEnrollments}
                queryName={"adminListEnrollments"}
                deleteMethod={deleteEnrollments}
                customFiltersData={customFiltersData}
                customFilters={
                    <div className={"row my-4 w-100"}>
                        <Col xs={12} sm={6} md={4}>
                            <Form.Group controlId={"enrollmentSearch"}>
                                <Form.Label>Buscar</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={searchFilterValue}
                                    onChange={(e: any) => setSearchFilterValue(e.target.value)}
                                    onKeyDown={onEnterPressed}
                                />
                            </Form.Group>
                        </Col>
                        <Col xs={12} sm={6} md={4}>
                            <Form.Group controlId={"enrollmentCenterFilter"}>
                                <Form.Label>Centro</Form.Label>
                                <CenterSelect
                                    value={selectedCenter}
                                    onChange={(option: SelectOptionType | null) => {
                                        setSelectedCenter(option)
                                        applyFilters(searchFilterValue, option)
                                    }}
                                />
                            </Form.Group>
                        </Col>
                        <Col xs={12} sm={12} md={4} className={"d-flex align-items-end"}>
                            <Button
                                className={"mt-2"}
                                variant={"secondary"}
                                onClick={() => {
                                    setSearchFilterValue('')
                                    setSelectedCenter(null)
                                    setCustomFiltersData({})
                                }}
                            >Limpiar filtros</Button>
                        </Col>
                    </div>
                }
                tableRow={(item: any, key: number) =>
                    <>
                        <td>
                            <Link to={ROUTE_PATHS.ADMIN_ENROLLMENTS_EDIT.replace(":id", item.id)}>
                                {item.name}
                            </Link>
                        </td>
                        <td>{item.price}</td>
                        <td>
                            <Enabled enabled={item.enabled} />
                        </td>
                        <td>{item.updatedAt}</td>
                        <td className={"text-center align-middle"}>
                            <Button
                                className={"purple-btn btn-sm"}
                                href={ROUTE_PATHS.ADMIN_ENROLLMENTS_EDIT.replace(":id", item.id)}
                            >
                                Modificar
                            </Button>
                        </td>
                    </>
                }
                createButton={
                    <>
                        <Button
                            className={"purple-btn"}
                            href={ROUTE_PATHS.ADMIN_ENROLLMENTS_CREATE}
                        >
                            Crear matrícula
                        </Button>
                        <Button
                            className={"ms-2"}
                            variant={"success"}
                            disabled={isExporting}
                            onClick={() => {
                                setIsExporting(true)
                                exportQuery.refetch()
                            }}
                        >
                            {isExporting ? 'Exportando ...' : 'Exportar'}
                        </Button>
                    </>
                }
            />
        </RequireAuth>
    )

}
